<template>
  <div class="about">
    <div class="is-hidden-touch" v-if="getViewPort() >= 1000">
      <navbar />
      <GeneralHero page="About" />
      <div v-if="!$store.getters.getLoading">
        <WhoWeAre1 />
        <WhoWeAre2 />
        <MissionStatement />
      </div>
      <Footer />
    </div>
    <div class="is-hidden-desktop" v-else>
      <NavMobile />
      <GeneralHeroMobile page="About" />
      <div v-if="!$store.getters.getLoading">
        <WhoWeAre1Mobile />
        <WhoWeAre2Mobile />
        <MissionStatementMobile />
      </div>
      <FooterMobile />
    </div>
  </div>
</template>

<script>
// import HelloWorld from '../components/HelloWorld'
import Navbar from "../components/GeneralComponent/Navbar";
import NavMobile from "../components/mobile/GeneralComponent/Navbar";
import GeneralHero from "../components/GeneralComponent/GeneralHero";
import GeneralHeroMobile from "../components/mobile/GeneralComponent/GeneralHero";
import WhoWeAre1 from "../components/AboutComponent/WhoWeAre1";
import WhoWeAre1Mobile from "../components/mobile/AboutComponent/WhoWeAre1";
import WhoWeAre2 from "../components/AboutComponent/WhoWeAre2";
import WhoWeAre2Mobile from "../components/mobile/AboutComponent/WhoWeAre2";
import MissionStatement from "../components/AboutComponent/MissionStatement";
import MissionStatementMobile from "../components/mobile/AboutComponent/MissionStatement";
import Footer from "../components/GeneralComponent/Footer";
import FooterMobile from "../components/mobile/GeneralComponent/Footer";

export default {
  name: "About",
  methods: {
    getViewPort() {
      return (window.innerWidth);
    }, //end of getViewPort
  },
  components: {
    // HelloWorld,
    Navbar,
    NavMobile,
    GeneralHero,
    GeneralHeroMobile,
    WhoWeAre1,
    WhoWeAre1Mobile,
    WhoWeAre2,
    WhoWeAre2Mobile,
    MissionStatement,
    MissionStatementMobile,
    Footer,
    FooterMobile,
  },
};
</script>
